import { isEqual } from "lodash";
import { useState } from "react";
export function useSelectionList(defaultVal = []) {
    const [items, setItems] = useState(defaultVal);
    const toggleItem = (item) => {
        setItems(prev => {
            const idx = prev.findIndex(cur => isEqual(cur, item));
            if (idx >= 0)
                return prev.slice(0, idx).concat(prev.slice(idx + 1));
            return prev.concat(item);
        });
    };
    const isSelected = (item) => items.findIndex(cur => isEqual(cur, item)) >= 0;
    const clear = () => setItems([]);
    return {
        items,
        replaceItems: setItems,
        toggleItem,
        isSelected,
        clear,
    };
}
//# sourceMappingURL=use-selection-list.js.map